import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,    
    CustomInput,
} from 'reactstrap';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import moment from 'moment';
export default function RoomSettings({option,handleOptionInputChange,Weekdays,handleAddIncludedItems,mews}) {    
    const operators=[
        {name:'equals',value:'equals'},{name:'Is less then',value:'Is less then'},{name:'Is greater then',value:'Is greater then'},{name:'Is less then or equal to',value:'Is less then or equal to'},{name:'Is greater then or equal to',value:'Is greater then or equal to'}
    ];
    return (
        <Fragment>
            <Colxx sm={3} className="mb-3">
                <Label>No. of Adults</Label>
                <Input
                    type="number"
                    value={option!==undefined && option.roomSettings.noOfAdults}
                    name="noOfAdults"
                    onChange={(event) =>
                        handleOptionInputChange(
                            event.target.name,
                            event.target.value,
                            option.id
                        )
                    }
                />
            </Colxx>
            {mews === undefined &&  <Colxx sm={3} className="mb-3">
                <Label>No. of Adults Operator</Label>
                <Input
                    type="select"
                    value={option!==undefined && option.roomSettings.noOfAdultsOperator}
                    name="noOfAdultsOperator"
                    onChange={(event) =>
                        handleOptionInputChange(
                            event.target.name,
                            event.target.value,
                            option.id
                        )
                    }
                >
                    {operators.map((m)=>(
                        <option value={m.name}>{m.name}</option>
                    ))}
                </Input>
            </Colxx>}
            <Colxx sm={3} className="mb-3">
                <Label> No. of Children </Label>
                <Input
                    type="number"
                    value={option!==undefined && option.roomSettings.noOfChildren}
                    name="noOfChildren"
                    onChange={(event) =>
                        handleOptionInputChange(
                            event.target.name,
                            event.target.value,
                            option.id
                        )
                    }
                />
            </Colxx>
            {mews === undefined && <Colxx sm={3} className="mb-3">
                <Label>No. of Children Operator</Label>
                <Input
                    type="select"
                    value={option!==undefined && option.roomSettings.noOfChildrenOperator}
                    name="noOfChildrenOperator"
                    onChange={(event) =>
                        handleOptionInputChange(
                            event.target.name,
                            event.target.value,
                            option.id
                        )
                    }
                    >
                    {operators.map((m)=>(
                        <option value={m.name}>{m.name}</option>
                    ))}
                </Input>
            </Colxx>}
            <Colxx sm={3} className="mb-3">
                <Label>No. of Nights</Label>
                <Input
                    type="number"
                    value={option!==undefined && option.roomSettings.noOfNights}
                    name="noOfNights"
                    onChange={(event) =>
                        handleOptionInputChange(
                            event.target.name,
                            event.target.value,
                            option.id
                        )
                    }
                />
            </Colxx>
            {mews === undefined &&   <Colxx sm={3} className="mb-3">
                <Label>No. of Rooms</Label>
                <Input
                    type="number"
                    value={option!==undefined && option.roomSettings.noOfRooms}
                    name="noOfRooms"
                    onChange={(event) =>
                        handleOptionInputChange(
                            event.target.name,
                            event.target.value,
                            option.id
                        )
                    }
                />
            </Colxx>}
 
            {mews === undefined &&  <Colxx sm={3} className="mb-3">
                <Label>Travel Start Date</Label>
                <Input
                    required
                    type="date"
                    name="travelStartDate"
                    value={option!==undefined && moment(option.roomSettings.travelStartDate).format('YYYY-MM-DD')}
                    onChange={(event) =>
                        handleOptionInputChange(
                            event.target.name,
                            event.target.value,
                            option.id
                        )}
                />
            </Colxx>}
            {mews === undefined &&  <Colxx sm={3} className="mb-3">
                <Label>Travel End Date</Label>
                <Input
                    required
                    type="date"
                    name="travelEndDate"
                    value={option!==undefined && moment(option.roomSettings.travelEndDate).format('YYYY-MM-DD')}
                    onChange={(event) =>
                        handleOptionInputChange(
                            event.target.name,
                            event.target.value,
                            option.id
                        )}
                />
            </Colxx>}
            <Colxx sm={3} className="mb-3">
                <Label>Booking Start Date</Label>
                <Input
                    required
                    type="date"
                    name="bookingStartDate"
                    value={option!==undefined && moment(option.roomSettings.bookingStartDate).format('YYYY-MM-DD')}
                    onChange={(event) =>
                        handleOptionInputChange(
                            event.target.name,
                            event.target.value,
                            option.id
                        )}
                />
            </Colxx>
            <Colxx sm={3} className="mb-3">
                <Label>Booking End Date</Label>
                <Input
                    required
                    type="date"
                    name="bookingEndDate"
                    value={option!==undefined && moment(option.roomSettings.bookingEndDate).format('YYYY-MM-DD')}
                    onChange={(event) =>
                        handleOptionInputChange(
                            event.target.name,
                            event.target.value,
                            option.id
                        )}
                />
            </Colxx>

            <Colxx sm={12}>
                <Row className="mb-2 ml-1">Available Days</Row>
                <Row className="mb-4">
                    {Weekdays !== undefined && Weekdays.map((m) =>
                        <Colxx sm={2}>
                            <CustomInput
                                type="checkbox"
                                checked={
                                    option!==undefined && option.roomSettings.days!==null &&                                
                                    option.roomSettings.days
                                        .split(',')
                                        .includes(m.name)
                                        ? true
                                        : false
                                }
                                value="Beach Access"
                                onChange={() => handleAddIncludedItems(m.name, option.id)}
                            >
                                <span style={{ lineHeight: '23px' }}>{m.name}</span>
                            </CustomInput>
                        </Colxx>)}
                </Row>
            </Colxx>
        </Fragment>
    );
}